import * as React from "react";
import { Accordion, Table } from "react-bootstrap";

import { HelpButton as HelpButtonBase } from "lib/components/HelpButton";

const commonThings = () => (
  <Accordion defaultActiveKey="0" className="mb-2">
    <Accordion.Item eventKey="0">
      <Accordion.Header>このページは？</Accordion.Header>
      <Accordion.Body>
        このページではイベント定義のキーの構成を編集することができます。
        <ul>
          <li>
            すでにNX開発機からデータを投稿済みの場合は、「定義の自動生成」ボタンを押して投稿済みのデータから定義を生成するのが簡単です。
          </li>
          <li>
            手動で定義を編集する場合、「キーを追加」ボタンをクリックしてキーを追加してください。
          </li>
          <li>
            キーは先頭が英字かアンダースコア、それ以降は英数字、アンダースコアのいずれかを用いて合計1~63文字の長さで入力してください。
          </li>
          <li>データ型については後述します。</li>
          <li>
            メモはシステムの動作には影響しません。備考欄として自由に記入してください。
          </li>
          <li>
            定義を変更した後は、「保存」を実行して、「BigQueryへの反映」のタブへ移動し、適宜各環境のテーブル定義に反映してください。
          </li>
        </ul>
      </Accordion.Body>
    </Accordion.Item>
  </Accordion>
);

const dataTypeTable = (
  <Accordion defaultActiveKey="0" className="mb-2">
    <Accordion.Item eventKey="0">
      <Accordion.Header>データ型について</Accordion.Header>
      <Accordion.Body>
        <Table>
          <thead>
            <tr>
              <th>データ型</th>
              <th>説明</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>SMALLINT </td>
              <td>符号付き 2 バイト整数 </td>
            </tr>
            <tr>
              <td>INTEGER </td>
              <td>符号付き 4 バイト整数 </td>
            </tr>
            <tr>
              <td>BIGINT </td>
              <td>符号付き 8 バイト整数 </td>
            </tr>
            <tr>
              <td>DECIMAL </td>
              <td>
                ユーザー定義可能な固定小数点数
                <ul>
                  <li>
                    DECIMAL(全体の桁数、小数の桁数)で定義します。全体の桁数の最大は38、小数の桁数は全体の桁数以下かつ37以下である必要があります。
                  </li>
                  <li>
                    集計速度の低速化などデメリットが多いので極力使用しないでください。
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>REAL </td>
              <td>
                単精度浮動小数点数
                <ul>
                  <li>
                    レポートは変換を通してサーバーに保存されているので、レポート作成時の精度を失っている可能性があります。
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>DOUBLE PRECISION </td>
              <td>
                倍精度浮動小数点数
                <ul>
                  <li>
                    レポートは変換を通してサーバーに保存されているので、レポート作成時の精度を失っている可能性があります。
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>BOOLEAN </td>
              <td>論理ブール演算型（true/false） </td>
            </tr>
            <tr>
              <td>CHAR </td>
              <td>
                固定長のキャラクタ文字列。列の幅の最大長は4096
                <ul>
                  <li>幅に満たない分はSELECT時にスペースが補完されます。</li>
                  <li>
                    送信される全ての文字列長が同じである場合にその長さを指定することでVARCHARよりもストレージを節約できます。
                  </li>
                  <li>
                    文字列長はバイト単位です。シングルバイト文字列のみ格納可能です。
                  </li>
                  <li>
                    lp1以外の環境では定義長を超える文字列はエラーになります。lp1環境では定義長を超える文字列は定義長まで丸められて格納されます。
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>VARCHAR </td>
              <td>
                ユーザーによって定義された制限を持つ可変長キャラクタ文字列。列の幅の最大長は65535
                <ul>
                  <li>
                    文字列長はバイト単位です。UTF-8で格納されるのでシングルバイト文字列以外を送信する場合には適切に文字列長を設定する必要があります。
                  </li>
                  <li>
                    lp1以外の環境では定義長を超える文字列はエラーになります。lp1環境では定義長を超える文字列は定義長まで丸められて格納されます。
                  </li>
                </ul>
              </td>
            </tr>
            <tr>
              <td>DATE </td>
              <td>カレンダー日付（年、月、日） </td>
            </tr>
            <tr>
              <td>TIMESTAMP </td>
              <td>日付と時刻（タイムゾーンなし） </td>
            </tr>
            <tr>
              <td>RECORD</td>
              <td>ネストされたデータ構造を表します。</td>
            </tr>
            <tr>
              <td>JSON</td>
              <td>JSON形式のデータを表します。</td>
            </tr>
          </tbody>
        </Table>
      </Accordion.Body>
    </Accordion.Item>
  </Accordion>
);

export function HelpButton() {
  return (
    <HelpButtonBase>
      {commonThings()}
      {dataTypeTable}
    </HelpButtonBase>
  );
}
